<script setup lang="ts">
import type { PropType } from 'vue';

import type { BlockItemProps } from '~/components/Block/BlockItem.vue';

// PROPS
defineProps({
    title: { type: String, default: '' },
    description: { type: String, default: '' },
    items: { type: Array as PropType<BlockItemProps[]>, default: () => [] },
});
</script>

<template>
    <BaseWidthContainer class="flex flex-col gap-y-6 md:gap-y-9 xl:grid xl:grid-cols-3 xl:gap-6">
        <div class="flex flex-col gap-2">
            <h4 v-if="!!title" class="text-highlighted text-left text-4xl font-semibold md:text-5xl">
                {{ title }}
            </h4>
            <p v-if="!!description" class="text-muted text-left font-medium md:text-xl">
                {{ description }}
            </p>
        </div>
        <div class="grid grid-cols-2 gap-4 md:gap-4 xl:col-span-2">
            <template v-for="(item, _index) in items" :key="_index">
                <slot name="item" :item="item">
                    <BlockItem v-bind="item" />
                </slot>
            </template>
        </div>
    </BaseWidthContainer>
</template>
